export default __webpack_public_path__ + "static/media/login-bg.9e42fa52.png";